import { Box, Typography } from "@mui/material";

function About() {
  return (
    <Box sx={{ maxWidth: "650px", m: "20px auto 200px" }}>
      <Typography
        sx={{
          fontFamily: "Outfit",
          fontSize: "32px",
          fontWeight: 600,
          color: "#fff",
          mb: 5,
        }}
      >
        About Us
      </Typography>
      <Typography
        sx={{
          fontFamily: "Outfit",
          fontSize: { xs: "17px", sm: "21px" },
          fontWeight: 400,
          color: "rgba(255, 255, 255, 0.75)",
        }}
      >
        Harbor Gate Global Inc is a US-based international exporting and trading
        company specializing in the distribution of strategic commodities,
        industrial materials, and high-demand goods across global markets.
        <br />
        <br />
        We are vertically integrated — overseeing every stage of the value chain
        from sourcing and refining to global delivery. This hands-on control
        ensures traceability, quality, and reliability at every phase of
        operation.
        <br />
        <br />
        Built on a foundation of integrity, efficiency, and cross-border
        expertise, we connect producers with buyers through reliable sourcing,
        secure transport, and tailored supply chain solutions. From metals like
        antimony and copper to agricultural and specialty goods, Harbor Gate
        Global serves as a trusted gatekeeper between opportunity and execution.
        <br />
        <br />
        Our name symbolizes what we offer: a safe, strategic entry point into
        global markets — where every transaction moves through a harbor of trust
        and into a gateway of growth.
      </Typography>
    </Box>
  );
}

export default About;
